<template>
  <v-main>
    <Navigation/>
    <guide-tour config-key="PostOperativeCare.listView"/>
    <v-tabs v-model="tab" right>
      <v-tab to="/post-operative-care/templates/list">設定</v-tab>
      <v-tab to="/post-operative-care/templates/schedule">發送排程</v-tab>
    </v-tabs>
    <router-view></router-view>
  </v-main>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
import GuideTour from "@/components/utils/GuideTour.vue";

export default {
  name: 'PostOperativeCareTemplateIndex',
  components: { Navigation, GuideTour },
  computed: {
    tab: {
      get() {
        const path = this.$route.path;
        if (path.includes('/schedule')) return 1;
        return 0;
      },
      set() {}
    }
  }
};
</script>
